import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { ArrowRight } from "lucide-react";

export default function Schools() {
  const { t, field } = useI18n();
  const [schools, setSchools] = useState([]);
  useEffect(() => { api.get("/schools").then((r) => setSchools(r.data)); }, []);
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>{t("schools_eyebrow")}</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">{t("schools_title")}</h1>
      <p className="mt-5 max-w-2xl text-ink/65 leading-relaxed">{t("schools_intro")}</p>
      <div className="mt-12 space-y-px bg-border border border-border">
        {schools.map((s) => (
          <Link key={s.slug} to={`/schools/${s.slug}`} data-testid={`school-card-${s.slug}`} className="group flex flex-col md:flex-row md:items-center gap-4 bg-paper p-8 hover:bg-secondary transition-colors">
            <div className="md:w-24 font-mono text-sm text-heraldic">{s.code}</div>
            <div className="flex-1">
              <div className="font-serif text-2xl text-ink">{field(s, "name")}</div>
              <div className="mt-1 text-ink/60">{field(s, "summary")}</div>
            </div>
            <ArrowRight className="h-5 w-5 text-ink/30 group-hover:translate-x-1 group-hover:text-heraldic transition-all" />
          </Link>
        ))}
      </div>
    </Section>
  );
}
